import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import classNames from "classnames";
import useIndexedDb from "../../hooks/useIndexedDb";
import styles from "./SideMenu.module.scss";
import { getEnvs } from "../../env";

type SideMenuProps = {
	open: boolean;
	close: () => void;
	toggleSitePins?: () => void;
	selectedMenuScreen: (screen: string) => void;
};

const SideMenu: React.FC<SideMenuProps> = ({
	open,
	close,
	toggleSitePins,
	selectedMenuScreen,
}) => {
	const history = useHistory();
	const [VERSION, setVERSION] = useState("");
	const [serverUrl, setServerUrl] = useState("");
	const [toastMessage, setToastMessage] = useState("Checking for updates...");
	const [openToast, setOpenToast] = useState(false);
	const [openLogoutMessage, setOpenLogoutMessage] = useState(false);
	const [getNewData, setGetNewData] = useState(false);
	useIndexedDb(getNewData);
	useEffect(() => {
		async function setupEnvs() {
			try {
				const envvars: any = await getEnvs();
				setVERSION(envvars.REACT_APP_VERSION);
				setServerUrl(envvars.REACT_APP_SERVER_URL_API)
			} catch (err) {
				setVERSION("");
			}
		}

		setupEnvs();
	}, []);
	const syncData = () => {
		setGetNewData(true);
		setOpenToast(true);
		setTimeout(() => {
			setToastMessage("Sites updated");
		}, 1000);
		setTimeout(() => {
			setOpenToast(false);
		}, 2000);
		setTimeout(() => {
			setToastMessage("Checking for updates...");
			setGetNewData(false);
		}, 4000);
	};
	const logout = async () => {
		setOpenLogoutMessage(false);
		let response;
		try {
			response = await fetch(`${serverUrl}/logout`, {
				method: "POST",
				credentials: "include",
				headers: {
					"Content-Type": "application/json",
				},
			});
		} catch (err) {
			console.error(err);
		}
		console.error(response);
		close();
		history.push("/");
	};

	return (
		<>
			<div
				className={classNames(styles.toast, {
					[styles.toastEnter]: openToast,
				})}
			>
				{toastMessage}
			</div>
			<div
				className={classNames(styles.logoutMessage, {
					[styles.logoutMessageEnter]: openLogoutMessage,
				})}
			>
				<p>
					Are you sure you want to log out? Please note any unsaved changes will
					be lost
				</p>
				<button
					onClick={()=>logout()}
				>
					Okay
				</button>
				<button
					onClick={() => {
						close();
						setOpenLogoutMessage(false);
					}}
				>
					Cancel
				</button>
			</div>
			<div
				className={classNames(styles.menu, {
					[styles.slideIn]: open,
				})}
			>
				<div className={styles.header}>
					<div className={styles.exitIconContainer} onClick={close}>
						<div className={styles.exitIcon} />
					</div>
				</div>
				<div className={styles.menuOptions}>
					<div className={styles.menuOption}>
						<p onClick={() => selectedMenuScreen("about")}>About</p>
						<p><a className={styles.privacyMenuItem} href="https://public.nrdigital.co/LSB/LSB+Portal+Privacy+Statement.pdf" target="_blank" rel="noopener noreferrer">Privacy</a></p>
						<p onClick={syncData}>Sync Data</p>
						<p onClick={() => setOpenLogoutMessage(true)}>Logout</p>
					</div>
				</div>
				<div />
			</div>
		</>
	);
};

export default SideMenu;
